module.exports = __webpack_public_path__ + "img/ID.c890662a.png";